/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { Box, TableCell, TableRow } from "@mui/material";
import styled from "styled-components";
import * as Sentry from "@sentry/react";
import { SERVICES } from "../../../../components/Layout/Services";
import { get } from "../../../../components/Layout/ApiHandler/apihandler";
import Loader from "../../../../components/Loader/Loader";
import NewTable from "../../../PendingOnlineContribution/Components/NewTable/NewTable";
import Pagination from "../../../../components/Layout/Pagination";

const DEFAULT_PAGE_SIZE = 5;

const CURRENT_APPOINTMENT_COL = [
  {
    displayName: "Position",
  },
  {
    displayName: "Division",
  },
  {
    displayName: "Sub Division",
  },
  {
    displayName: "Location",
  },
  {
    displayName: "Appointment From Date",
  },
  {
    displayName: "Appointment To Date",
  },
  {
    displayName: "Mainline/Dual Resp.",
  },
  {
    displayName: "Organization Structure",
  },
];

function PreviousAppointment() {
  const { memberId } = useParams();
  const [previousAppointments, setPreviousAppointments] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const getCurrentAppointments = async () => {
    try {
      const url = `${SERVICES.GET_MEMBER}/${memberId}/appointments?status=RETIRED&size=${DEFAULT_PAGE_SIZE}`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setPreviousAppointments(data.data);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const pageCount = previousAppointments.totalPages;
  const handlePageChange = async (selectedPage) => {
    setIsLoading(true);
    setCurrentPage(selectedPage);
    try {
      const url = `${SERVICES.GET_MEMBER}/${memberId}/appointments?status=RETIRED&page=${selectedPage}&size=${DEFAULT_PAGE_SIZE}`;
      const response = await get(url);

      if (response && response.ok) {
        const data = await response.json();
        setPreviousAppointments(data.data);
      } else {
        console.error("Failed to fetch contribution data");
        setIsLoading(false);
      }
    } catch (error) {
      Sentry.captureException(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const handleChangePage = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
    handlePageChange(selectedPage.selected);
  };
  const getDirectAppointmentType = (positionType) => {
    if (positionType === "DEPUTY_POSITION") {
      return "DUAL";
    }
    return positionType?.length ? positionType.split("_")[0] : "";
  };
  const getRows = (data) =>
    data.map((previousAppointmentInfo, index) => {
      return (
        <TableRow key={index}>
          <TableCell>{previousAppointmentInfo?.appliedForName || ""}</TableCell>
          <TableCell>{previousAppointmentInfo?.divisionName || ""}</TableCell>
          <TableCell>
            {previousAppointmentInfo?.subDivisionName || ""}
          </TableCell>
          <TableCell>{previousAppointmentInfo?.location || ""}</TableCell>
          <TableCell>
            {moment(previousAppointmentInfo?.createdAt).format("DD/MM/YYYY")}
          </TableCell>
          <TableCell>
            {moment(previousAppointmentInfo?.deactivatedAt).format(
              "DD/MM/YYYY",
            )}
          </TableCell>
          <TableCell>
            {getDirectAppointmentType(
              previousAppointmentInfo?.appointmentApplicationType,
            )}
          </TableCell>
          <TableCell>{`${previousAppointmentInfo?.currentAreaName || ""}/
          ${previousAppointmentInfo?.currentClusterName || ""}/${
            previousAppointmentInfo?.currentZoneName || ""
          }/${previousAppointmentInfo?.currentRegionName || ""}/${
            previousAppointmentInfo?.currentChapterName || ""
          }/${previousAppointmentInfo?.currentDistrictName || ""}`}</TableCell>
        </TableRow>
      );
    });
  useEffect(() => {
    getCurrentAppointments();
  }, [memberId]);
  return (
    <Box sx={{ width: "100%" }}>
      {previousAppointments.content?.length > 0 ? (
        <Box>
          <NewTable
            columns={CURRENT_APPOINTMENT_COL}
            rows={getRows(previousAppointments.content)}
          />
          <Pagination
            pageCount={pageCount}
            onPageChange={handleChangePage}
            forcePage={currentPage}
          />
        </Box>
      ) : (
        <NodataText>No details found.</NodataText>
      )}
      {isLoading && <Loader />}
    </Box>
  );
}

export default PreviousAppointment;

const NodataText = styled.p`
  color: #e41717;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 125%;
`;
